
// ! rename the function to align with the widget name
export const customFooter = () => {
    const el = document.querySelector('.curious-home-hero');
    if (!el) return;

    // ------------------------------------------------------------

   

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

